<template>
  <section>
    <b-modal :id="modalId" :ref="modalId" size="xl" @shown="initializeModal" title="Nonconformance Report" scrollable>
      <b-card title="Identification">
          <div class="mb-2" style="display: grid; grid-template-rows: repeat(7, 0fr); grid-template-columns: repeat(2, 1fr); grid-column-gap: 0.75rem; grid-row-gap: 0.5rem">
            <b-form-group label="Originator Name" class="required" style="grid-column: 1;">            
                <b-form-input v-model="ncmReport.originatorName"  :class="is-invalid"></b-form-input>
            </b-form-group>
            <!--<b-form-group label="Vendor/Supplier" style="grid-column: 1;">
                <lookup-dropdown
                  label="manufacturer"
                  moduleName="manufacturers"
                  resource="inventoryManufacturer"
                  propKey="mfrId"
                  :value="ncmReport.mfrId"
                  :options="manufacturers"
                  :overrideModalId="'ncm-report-mfr'"
                  @change="onValueChangePart"
                />
            </b-form-group>
            <b-form-group label="NC No." style="grid-column: 2; grid-row: 2">
              <b-form-input v-model="ncmReport.ncNumber" />
            </b-form-group>-->
            <b-form-group label="Vendor/Supplier" style="grid-column: 1;">
              <b-form-input v-model="ncmReport.vendorName" disabled/>
            </b-form-group>
            <b-form-group label="Date" style="grid-column: 2; grid-row: 1">
              <date-picker v-model="ncmReport.dateInspected" :config="datePickerOptions"></date-picker>
            </b-form-group>
            <b-form-group label="NC No." style="grid-column: 2; grid-row: 2" v-if="showNcNo">
              <b-form-input v-model="ncmReport.id" disabled/>
            </b-form-group>
            <b-form-group label="Purchase Order Id" style="grid-column: 1; grid-row: 3">
              <b-form-input v-model="ncmReport.purchaseOrderId" disabled />
            </b-form-group>
            <b-form-group label="Part Number" style="grid-column: 1; grid-row: 4">
              <b-form-input v-model="ncmReport.partNumber" disabled />
            </b-form-group>
            <b-form-group label="Qty" style="grid-column: 2; grid-row: 3">
              <b-form-input v-model="ncmReport.quantity" />
            </b-form-group>
            <b-form-group label="Dwg No" style="grid-column: 2; grid-row: 4">
              <b-form-input v-model="ncmReport.dwgNumber" />
            </b-form-group>
            <b-form-group label="Non-Conformance found by" style="grid-column: 1; grid-row: 5">
              <b-form-radio-group v-model="ncmReport.ncmActivityInspectionId" name="ncmInspectionActivityId">
                <b-form-radio v-for="(select, index) in ncmInspectionActivity" :key="index" :value="select.id">
                {{ select.name }}
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group label="Description of nonconformance" style="grid-column: 1; grid-row: 6">
              <b-textarea v-model="ncmReport.description" />
            </b-form-group>
            <b-form-group label="Action taken to prevent misuse" style="grid-column: 2; grid-row: 6">
              <b-textarea v-model="ncmReport.action" />
            </b-form-group>
          </div>
      </b-card>
      <b-card title="Disposition">
          <div class="mb-2" style="display: grid; grid-template-rows: repeat(3, 0fr); grid-template-columns: repeat(3, 1fr); grid-column-gap: 0.75rem; grid-row-gap: 0.5rem">
            <b-form-group label="Disposition Action" style="grid-column: 1; grid-row: 1">
              <b-form-radio v-for="(select, index) in ncmDispositionAction" :key="index" :value="select.id"
                v-model="ncmReport.ncmDispositionActionId" name="ncmDispositionActionId" >
                {{ select.name }}
              </b-form-radio>
            </b-form-group>
            <b-form-group label="Responsible Manager" style="grid-column: 2; grid-row: 1">
              <b-form-input v-model="ncmReport.responsibleManager" placeholder="Responsible Manager Name" />
              <date-picker v-model="ncmReport.responsibleManagerDate" :config="datePickerOptions" placeholder="Date"></date-picker>
            </b-form-group>
            <b-form-group label="Approval of Use-As-Is Disposition" style="grid-column: 1; grid-row: 2" :disabled="ncmReport.ncmDispositionActionId != 465">
              <b-form-radio v-model="ncmReport.IsCriticalNCForUseAsIsDisposition" name="IsCriticalNCForUseAsIsDisposition" :value="false">
                Non-critical NC
              </b-form-radio>
              <b-form-radio v-model="ncmReport.IsCriticalNCForUseAsIsDisposition" name="IsCriticalNCForUseAsIsDisposition-radios" :value="true">
                Critical NC
              </b-form-radio>
            </b-form-group>
            <b-form-group label="Project Engineer" style="grid-column: 2; grid-row: 2" :disabled="ncmReport.ncmDispositionActionId != 465">
              <b-form-input v-model="ncmReport.projectEngineer" placeholder="Project Engineer Name" />
              <date-picker v-model="ncmReport.projectEngineerDate" :config="datePickerOptions" placeholder="Date Approved"></date-picker>
            </b-form-group>
            <b-form-group label="Project Management" style="grid-column: 3; grid-row: 2" :disabled="ncmReport.ncmDispositionActionId != 465">
              <b-form-input v-model="ncmReport.projectManagement" placeholder="Project Management Name" />
              <date-picker v-model="ncmReport.projectManagementDate" :config="datePickerOptions" placeholder="Date Approved"></date-picker>
            </b-form-group>
            <b-form-group label="Approval of repair, rework, return to supplier, rejection disposition" style="grid-column: 1; grid-row: 3" :disabled="ncmReport.ncmDispositionActionId== 465">
              <b-form-input v-model="ncmReport.dispositionApprovedBy" placeholder="Project Engineer Name" />
              <date-picker v-model="ncmReport.dispositionApprovedDate" :config="datePickerOptions" placeholder="Date Approved"></date-picker>
            </b-form-group>
          </div>
      </b-card>
      <b-card title="Corrective/Preventive Action">
        <div class="mb-2" style="display: grid; grid-template-rows: repeat(1, 0fr); grid-template-columns: repeat(2, 1fr); grid-column-gap: 0.75rem; grid-row-gap: 0.5rem">
          <b-form-group label="Description of proposed action" style="grid-column: 1; grid-row: 1">
            <b-textarea v-model="ncmReport.correctiveActionDescription" />
          </b-form-group>
          <b-form-group label="Approval of corrective/preventive action" style="grid-column: 2; grid-row: 1">
            <b-form-input v-model="ncmReport.correctiveActionApprovedBy" placeholder="Project Engineer Name" />
            <date-picker v-model="ncmReport.correctiveActionApprovedDate" :config="datePickerOptions" placeholder="Date"></date-picker>
          </b-form-group>
        </div>
      </b-card>
      <b-card title="Closing the NonConformance">
        <div class="mb-2" style="display: grid; grid-template-rows: repeat(1, 0fr); grid-template-columns: repeat(2, 1fr); grid-column-gap: 0.75rem; grid-row-gap: 0.5rem">
          <b-form-group label="Planned disposition has been completed and corrective/preventive action has been initiated" style="grid-column: 1; grid-row: 1">
            <b-form-input v-model="ncmReport.closingNcmBy" placeholder="Responsibe Manager Name" />
            <date-picker v-model="ncmReport.closingNcmDate" :config="datePickerOptions" placeholder="Date"></date-picker>
          </b-form-group>
        </div>
      </b-card>
      <template slot="modal-footer">
        <b-button variant="primary" class="mr-auto" @click="onPrintNcm" v-if="ncmReport.id > 0">Print</b-button>
        <b-button @click="$bvModal.hide(modalId)">Cancel</b-button>
        <b-button variant="primary" @click="onSaveNcmReport" :disabled="isSaving">Save</b-button>
      </template>
    </b-modal>
    <fast-report-viewer ref="ncm-print" :modalId="'ncm-print'" :parameter="ncmReport.id" :moduleName="'NCM'" />
  </section>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import moment from 'moment';
import {DATE_FORMAT} from '@/shared/constants';
import FastReportViewer from '@/shared/components/FastReportViewer';

export default {
  components: {
    FastReportViewer
  },
  props: {
    ncmProp: {
      type: Object,
      default: null
    },
    inventoryProp: {
      type: Object,
      default: null
    },
    poLineProp: {
      type: Object,
      default: null
    },
    rmaLineProp: {
      type: Object,
      default: null
    },
    modalId: {
      type: String,
      default: 'ncm-report-modal-inventory'
    }
  },
  data() {
    return {
      ncmReport: {},
      datePickerOptions: {
        format: DATE_FORMAT,
        useCurrent: false,
      },
      isSaving: false,
    }
  },
  computed: {
    ...mapGetters('lookup', [ 'manufacturers', 'ncmInspectionActivity', 'ncmDispositionAction' ]),
    showNcNo(){
      return (this.ncmReport.id)? true: false;
    },
    isRmaNcm() {
      return this.rmaLineProp != null && Object.keys(this.rmaLineProp).length > 0;
    }
  },
  methods: {
    ...mapActions('ncmReports', ['saveNcmReport']),
    onValueChangePart({ name, value }) {
      this.ncmReport = {
        ...this.ncmReport,
        [name]: value,
      };
    },
    initializeModal() {
      if (this.ncmProp != null && Object.keys(this.ncmProp).length > 0) {
        this.ncmReport = { ...this.ncmProp, dateInspected: moment(this.ncmProp.dateInspected).format(DATE_FORMAT)};
      } else {
        const ncmObj = (this.inventoryProp != null && Object.keys(this.inventoryProp).length > 0) ? this.inventoryProp
          : (this.poLineProp != null && Object.keys(this.poLineProp).length > 0) ? this.poLineProp
          : (this.rmaLineProp != null && Object.keys(this.rmaLineProp).length > 0) ? this.rmaLineProp : {}

        if (Object.keys(ncmObj).length > 0) {

          console.log('ncmObj :', );
          
          this.ncmReport = {
            dateInspected: moment(new Date()).format(DATE_FORMAT),
            partId: ncmObj.partId,
            partNumber: ncmObj.partNumber,
            purchaseOrderLineId: this.inventoryProp != null ? ncmObj.purchaseOrderLineId : this.rmaLineProp != null ? ncmObj.poLineId : ncmObj.id,
            purchaseOrderId: ncmObj.purchaseOrderId,
            rmaLineId: this.rmaLineProp != null ? ncmObj.id : 0,
            vendorName: (!this.isRmaNcm) ? ncmObj.companyName : ncmObj.vendorName
          }
        } else {
          this.openAlertBox({ message: 'No Inventory Record Found thus we cannot proceed in creating NCM' }).then(() => {
            this.$bvModal.hide(this.modalId);
          })
        }
      }

      // console.log('this.ncmReport :', this.ncmReport);

    },
    async onSaveNcmReport() {
      this.isSaving = true;
      if(this.ncmReport.originatorName!=undefined){
      await this.saveNcmReport(this.ncmReport).then(() => {
        this.$snotify.success('NCM Report Saved');
        this.$emit('savedNcm');
      }).catch(() => {
        this.$snotify.error('An error occurred');
        this.isSaving = false;
      })
      this.$bvModal.hide(this.modalId);
      }
      else{

        this.isSaving = false;
      }
      this.isSaving = false;
    },
    show() {
      this.$bvModal.show(this.modalId);
    },
    async onPrintNcm() {
      await this.onSaveNcmReport();
      this.$refs['ncm-print'].showModal();
    }
  }
}
</script>
